import { render, staticRenderFns } from "./audioComp.vue?vue&type=template&id=17a95414&scoped=true"
import script from "./audioComp.vue?vue&type=script&lang=js"
export * from "./audioComp.vue?vue&type=script&lang=js"
import style0 from "./audioComp.vue?vue&type=style&index=0&id=17a95414&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a95414",
  null
  
)

export default component.exports